var micrositePages = (function () {
  return {
    init: init,
  };

  function init() {
    uiBindings();

    //image modal
    tingleImgModal();

    //table responsive class
    var tableContent = document.querySelectorAll('table');
    for (var j = 0; j < tableContent.length; j++) {
      if (!tableContent[j].parentElement.classList.contains("table-responsive")) {
        var wrapper = document.createElement('div');
        wrapper.classList.add("table-responsive");
        wrapper.appendChild(tableContent[j].cloneNode(true)); 
        tableContent[j].parentNode.replaceChild(wrapper, tableContent[j]);
      }
    }
  }

  function uiBindings() {
    //Sidebar
    window.addEventListener('load', getSidebar);
    window.addEventListener('scroll', getSidebar);
    window.addEventListener('resize', getSidebar);

    //Progress Bar
    window.addEventListener('scroll', getProgressBar);

    //Amplitude events
    window.addEventListener('load', eventsTracker);
  }

  function eventsTracker() {
    //load event
    if (window.hasOwnProperty('loadWebTrackerEvents')) {
      loadWebTrackerEvents.push({
        eventName: 'OnLoadSEOMicrositeLP',
        eventProperty: {},
      });
    }

    var linksElems = document.querySelectorAll('a, button');
    if (linksElems.length > 0) {
      for (var i = 0; i < linksElems.length; i++) {
        var ele = linksElems[i];

        ele.addEventListener('click', function (e) {
          var that = this,
            eventName = 'InteractedWithSEOMicrositeLP',
            eventObj = {
              action: 'click',
              text: that.textContent,
            };

          if (that.closest('.microsite-templ-hero')) {
            eventObj.section = 'Hero';
          } else if (that.closest('.microsite-templ-ctasec')) {
            eventObj.section = 'Footer CTA';
          } else if (that.closest('.microsite-templ-sidebar-abs .bstack-toc')) {
            eventObj.section = 'Sidebar TOC';
          } else if (that.closest('.bstack-toc')) {
            eventObj.section = 'TOC';
          } else if (that.closest('.microsite-templ-sidebar__other-links')) {
            eventObj.section = 'Sidebar links';
          } else if (that.closest('.bstack-main-content-breadcrumbs')) {
            eventObj.section = 'Breadcrumbs';
          } else if (that.closest('.microsite-templ-main-content')) {
            eventObj.section = 'Main Content';
          }

          if (window.hasOwnProperty('WebEventTracker')) {
            WebEventTracker.logEvent(EDS.webEvents, eventName, eventObj);
          }
        });
      }
    }
  }

  function getProgressBar() {
    var pixels = window.pageYOffset,
      pageHeight = document.body.scrollHeight - window.innerHeight,
      progress = (100 * pixels) / pageHeight,
      progressDom = document.querySelector('.microsite-templ-progress-bar');

    progressDom.style.width = progress + '%';
  }

  function getSidebar() {
    var sidebar = document.getElementById('microsite-templ-sidebar-abs'),
      content = document.querySelector('.microsite-templ-content');

    if (window.innerWidth > 979 && sidebar) {
      if (window.pageYOffset > content.scrollHeight + content.offsetTop - sidebar.offsetHeight - 84) {
        sidebar.classList.remove('bs-no-stick');
        sidebar.classList.add('bs-stick-bottom');
      } else if (sidebar.classList.contains('bs-stick-bottom')) {
        sidebar.classList.remove('bs-stick-bottom');
        if (!sidebar.classList.contains('bs-stick-top')) {
          sidebar.classList.add('bs-no-stick');
        }
      } else if (window.pageYOffset > content.offsetTop - 27) {
        if (!sidebar.classList.contains('bs-stick-top')) {
          // Avoid flickering by adding sticky class only once.
          sidebar.classList.remove('bs-no-stick');
          sidebar.classList.add('bs-stick-top');
        }
      } else {
        sidebar.classList.remove('bs-stick-top');
        sidebar.classList.add('bs-no-stick');
      }
    }
  }

  function tingleImgModal() {
    var mainWrap, modalOverlay;
    mainWrap = document.querySelector('.microsite-templ-main-content');
    modalOverlay = mainWrap.querySelectorAll('img:not(.no-full-size)');
    if (modalOverlay) {
      for (var i = 0; i < modalOverlay.length; i++) {
        var ele = modalOverlay[i];
        imgWidth = ele.getAttribute('width');
        if (imgWidth < 150) {
          continue;
        }

        ele.style.cursor = 'pointer';
        ele.addEventListener('click', function (e) {
          e.preventDefault();
          var that = this,
            modalImg = that.getAttribute('src'),
            modalWidth = that.getAttribute('width'),
            modalHeight = that.getAttribute('height'),
            modalAlt = that.getAttribute('alt');

          if (modalImg) {
            var modalVideo = new tingle.modal({
              focusAfterClosed: that,
              closeIconInverse: true,
              cssClass: ['microsite-templ-modal-image'],
              onClose: function () {
                modalVideo.destroy();
              },
            });
            modalVideo.setContent('<img src="' + modalImg + '" width="'+ modalWidth +'" height="'+ modalHeight +'" alt="' + modalAlt + '">');
            modalVideo.open();

            //Event
            if (window.hasOwnProperty('WebEventTracker')) {
              WebEventTracker.logEvent(EDS.webEvents, 'InteractedWithSEOMicrositeLP', {
                action: 'click',
                section: 'image',
                text: modalImg.split("/").pop()
              });
            }
          }
        });
      }
    }
  }
})();

micrositePages.init();
